import React, { Component, Fragment } from "react";
import { withStyles } from '@material-ui/core/styles';
import { withRouter } from 'react-router-dom';
import { FusePageSimple } from "@fuse";
import { Typography, Button } from '@material-ui/core';
import axiosInstance from "../common/AxiosInstace";
import EndpointsGetter from '../common/EndpointsGetter';
import CircularProgress from '@material-ui/core/CircularProgress';
import classNames from 'classnames';
import { LoaderGunSettings } from './settings-sections/LoaderGunSettings';
import { DataGroupSettings } from './settings-sections/DataGroupSettings';
import SnackBar from '../common/Snackbar';
import { Prompt } from 'react-router-dom';
import cloneDeep from 'lodash/cloneDeep';
import isEqual from 'lodash/isEqual';
import isEmpty from 'lodash/isEmpty';

const styles = theme => ({
    layoutRoot: {},
    formControl: {
        margin: '6px 0',
        width: '100%',
        '&:last-child': {
            marginBottom: 0
        }
    },
    formGroup: {
        position: 'relative',
        border: '1px solid ' + theme.palette.divider,
        borderRadius: 2,
        padding: '12px 12px 0 12px',
        '&:first-of-type': {
            marginTop: 16,
            marginBottom: 16
        }
    },
    formGroupTitle: {
        position: 'absolute',
        top: -10,
        left: 8,
        fontWeight: 500,
        padding: '0 4px',
        backgroundColor: '#FAFAFA',
        fontSize: '18px'
    },
    circularProgress: {
        position: 'absolute',
        zIndex: '1',
        marginLeft: 'auto',
        marginRight: 'auto',
        top: '50%',
        left: '50%'
    },
    textField: {}
});

class Settings extends Component {
    state = {
        accountDetails: {},
        accDetailsOrigin: {},
        unsavedChanges: false,
        errorString: '',
        isLoading: '',
        showMessage: false,
        successMessage: ''
    };

    componentDidMount() {
        let accessToken = localStorage.getItem("access_token");
        if (accessToken == null || typeof accessToken == "undefined") {
            this.props.history.push('/login');
        } else {
            this.getAccountDetails(accessToken);
        }
    }

    componentDidUpdate = (prevProps, prevState) => {
        if (!isEmpty(prevState.accountDetails) && !isEmpty(this.state.accountDetails)) {
            if (!isEqual(this.state.accountDetails, this.state.accDetailsOrigin)) window.onbeforeunload = () => true;
            else window.onbeforeunload = undefined;
        }
    }

    getAccountDetails = (accessToken) => {
        this.setState({ isLoading: true });
        axiosInstance.get(`${EndpointsGetter.getAccountDetailsEndpoint()}`, {
            headers: {
                'Authorization': 'Bearer ' + accessToken
            }
        })
            .then(response => {
                this.setState({ isLoading: false, accountDetails: { ...response.data }, accDetailsOrigin: cloneDeep({ ...response.data }) });
            })
            .catch(error => {
                this.getError(error);
            });
    }

    detailsChange = (value, field) => {
        let accoundDetailsUpdate = { ...this.state.accountDetails };
        accoundDetailsUpdate[field] = value;
        this.setState({ accountDetails: accoundDetailsUpdate });
    }

    saveSettings = () => {
        this.updateAccountSettings();
    }

    updateAccountSettings = () => {
        let accessToken = localStorage.getItem("access_token"),
            { accountDetails } = this.state;

        let lgRequestBody = {
            account: accountDetails.accountKey,
            tps: accountDetails['lgTpsLimit'],
            duration: accountDetails['lgDurationLimit']
        }
        this.setState({ isLoading: true });

        axiosInstance.post(`${EndpointsGetter.getAccountDetailsEndpoint()}/loadergun`, lgRequestBody, {
            headers: {
                'Authorization': 'Bearer ' + accessToken
            }
        }).catch(error => {
            this.getError(error);
        });

        let dgRequestBody = {
            account: accountDetails.accountKey,
            aggregationsLimit: accountDetails['aggregationsLimit'],
            dimensionsLimit: accountDetails['dimensionsLimit'],
            dimAttributeLimit: accountDetails['dimAttributeLimit']
        }
        axiosInstance.post(`${EndpointsGetter.getAccountDetailsEndpoint()}/dgsettings`, dgRequestBody, {
            headers: {
                'Authorization': 'Bearer' + accessToken
            }
        }).then(response => {
            this.setState({
                isLoading: false,
                showMessage: true,
                successMessage: `Successfully updated account's settings.`,
                accDetailsOrigin: cloneDeep(accountDetails)
            });
        })
            .catch(error => {
                this.getError(error);
            });
    }

    disableSaveButton = () => {
        let { accountDetails, accDetailsOrigin } = this.state;
        return (accountDetails.lgDurationLimit < 1 || accountDetails.lgDurationLimit > 10000 || !accountDetails.lgDurationLimit) ||
            (accountDetails.lgTpsLimit < 1 || accountDetails.lgTpsLimit > 10000 || !accountDetails.lgTpsLimit) ||
            (accountDetails.aggregationsLimit < 1 || accountDetails.aggregationsLimit > 50 || !accountDetails.aggregationsLimit) ||
            (accountDetails.dimensionsLimit < 1 || accountDetails.dimensionsLimit > 50 || !accountDetails.dimensionsLimit) ||
            (accountDetails.dimAttributeLimit < 1 || accountDetails.dimAttributeLimit > 5 || !accountDetails.dimAttributeLimit) ||
            isEqual(accountDetails, accDetailsOrigin);
    }

    getError = (error) => {
        let errorString = '';
        if (error.code === 'ECONNABORTED') {
            errorString = "API Request timed out. Please try again after few seconds";
        } else if (error.response.status === 500) {
            errorString = "Operation was unsuccessful. Please try again after few seconds";
        } else if (error.response.status === 404) {
            errorString = "Error 404";
        } else if (error.response.status === 401) {
            // errorString = "Unauthorized";
        } else {
            errorString = error.response.data.message ? error.response.data.message : error.response.data.error_description;
            if (error.response.status === 400 && errorString.includes("Invalid refresh token")) {
                this.props.history.push('/login');
            }
        }
        this.setState({ errorString: errorString, isLoading: false });
    }

    render() {
        let { classes } = this.props,
            { isLoading, errorString, accountDetails, showMessage, successMessage, accDetailsOrigin } = this.state;

        return (
            <Fragment>
                {isLoading ? <CircularProgress className={classNames(classes.circularProgress, classes.progress)} color="secondary" /> : null}
                <div style={{ pointerEvents: isLoading ? 'none' : 'auto', 'filter': isLoading ? 'blur(1px)' : 'blur(0px)', height: '100%' }}>
                    <FusePageSimple
                        classes={{
                            root: classes.layoutRoot
                        }}
                        header={
                            <div className='header-container justify-between'>
                                <h3 className='header-title'>Settings</h3>
                                <div className="float-right">
                                    <Button
                                        className='btn-primary mr-20'
                                        variant="outlined"
                                        color="secondary"
                                        onClick={this.saveSettings}
                                        disabled={this.disableSaveButton()}
                                    >
                                        Save
                                </Button>
                                </div>
                            </div>
                        }
                        content={
                            <div className="p-24 m-auto" style={{ maxWidth: '1000px' }}>
                                {errorString ? (
                                    <div>
                                        <label className="text-area-label" style={{ color: 'red', padding: '0', wordBreak: 'break-word' }}>
                                            {errorString}
                                        </label>
                                    </div>
                                ) : null}
                                {
                                    !isEmpty(accountDetails) ? (
                                        <div>
                                            <div className={classes.formGroup}>
                                                <Typography className={classes.formGroupTitle} color="textSecondary">
                                                    Loader Gun
                                                </Typography>

                                                <LoaderGunSettings
                                                    tpsLimit={accountDetails['lgTpsLimit'] ? accountDetails['lgTpsLimit'] : ""}
                                                    duration={accountDetails['lgDurationLimit'] ? accountDetails['lgDurationLimit'] : ""}
                                                    onChange={this.detailsChange}
                                                />
                                            </div>
                                            <div className={classes.formGroup}>
                                                <Typography className={classes.formGroupTitle} color="textSecondary">
                                                    Datagroup Settings
                                                    </Typography>

                                                <DataGroupSettings
                                                    aggregationLimit={accountDetails['aggregationsLimit'] ? accountDetails['aggregationsLimit'] : ""}
                                                    dimensionLimit={accountDetails['dimensionsLimit'] ? accountDetails['dimensionsLimit'] : ""}
                                                    dimAttributeLimit={accountDetails['dimAttributeLimit'] ? accountDetails['dimAttributeLimit'] : ""}
                                                    onChange={this.detailsChange}
                                                />
                                            </div>
                                        </div>
                                    ) : null
                                }
                            </div>
                        }
                    />
                    <SnackBar
                        open={showMessage}
                        duration={3000}
                        message={successMessage}
                        variant='success'
                        handleClose={() => this.setState({ showMessage: false, successMessage: '' })}
                    />
                    <Prompt
                        when={!isEqual(accountDetails, accDetailsOrigin)}
                        message={"You have unsaved changes. Are you sure you want to leave?"} />
                </div>
            </Fragment>
        )
    }
}

export default withStyles(styles, { withTheme: true })(withRouter(Settings));


// WEBPACK FOOTER //
// ./src/main/content/settings/Settings.js